import * as libFund from './fund';
import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const prefix = 'variants';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ fundID, variantID }) => {
    return libFund.IDToName({ fundID }) + '/' + prefixWithSeparator + variantID;
};
export const validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        variantID: parts[3],
    };
};
